import React from "react";
import { toast } from "@/shared/utils/toast";
import WebsiteAnalysisToastPanel from "@/features/onboarding/components/Onboarding/WebsiteAnalysisToastPanel";
import { useWebsiteAnalysisToastStore } from "@/features/onboarding/stores/websiteAnalysisToastStore";

export const WEBSITE_ANALYSIS_TOAST_ID = "sw-website-analysis";

let userDismissedWhileRunning = false;

export function resetWebsiteAnalysisDismissFlag() {
  userDismissedWhileRunning = false;
}

export function wasWebsiteAnalysisToastDismissed() {
  return userDismissedWhileRunning;
}


export function openWebsiteAnalysisToast({ brandLabel, hostScan, patch = {} }) {
  resetWebsiteAnalysisDismissFlag();
  useWebsiteAnalysisToastStore.getState().reset();
  useWebsiteAnalysisToastStore.getState().setPatch({
    brandLabel,
    hostScan,
    headerSubtitle: patch.headerSubtitle ?? "Scanning your website...",
    phases: patch.phases ?? ["active", "pending", "pending"],
    progress: patch.progress ?? 10,
  });

  if (!toast.isActive(WEBSITE_ANALYSIS_TOAST_ID)) {
    toast(
      ({ closeToast }) =>
        React.createElement(WebsiteAnalysisToastPanel, {
          onDismiss: () => {
            userDismissedWhileRunning = true;
            closeToast();
            useWebsiteAnalysisToastStore.getState().reset();
          },
        }),
      {
        toastId: WEBSITE_ANALYSIS_TOAST_ID,
        position: "bottom-right",
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false,
        hideProgressBar: true,
        icon: false,
        className:
          "!bg-transparent !shadow-none !p-0 !m-0 !border-0 !min-h-0 !w-max !max-w-none",
        bodyClassName: "!p-0 !m-0",
      },
    );
  }
}

export function patchWebsiteAnalysisToast(partial) {
  useWebsiteAnalysisToastStore.getState().setPatch(partial);
}

export function dismissWebsiteAnalysisToast() {
  if (toast.isActive(WEBSITE_ANALYSIS_TOAST_ID)) {
    toast.dismiss(WEBSITE_ANALYSIS_TOAST_ID);
  }
  useWebsiteAnalysisToastStore.getState().reset();
}
